import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

export const DEFAULT_SUBMISSION_VERSION = 'Latest'

const initialState = {
    selectedVersionId: DEFAULT_SUBMISSION_VERSION,
    selectedSubmissionIds: [],
    openedSubmissionId: null,
    groupsAtSubmissionOpenMoment: null,
}

const submissionSlice = createSlice({
    name: 'submission',
    initialState,
    reducers: {
        setSelectedVersionId: (state, action) => {
            state.selectedVersionId = action.payload
        },
        addSelectedSubmissionId: (state, action) => {
            state.selectedSubmissionIds.push(action.payload)
        },
        removeSelectedSubmissionId: (state, action) => {
            state.selectedSubmissionIds = state.selectedSubmissionIds.filter(id => id !== action.payload)
        },
        addManySelectedSubmissionIds: (state, action) => {
            state.selectedSubmissionIds = [...new Set([...state.selectedSubmissionIds, ...action.payload])]
        },
        removeManySelectedSubmissionIds: (state, action) => {
            state.selectedSubmissionIds = state.selectedSubmissionIds.filter(id => !action.payload.includes(id))
        },
        setSelectedSubmissionIds: (state, action) => {
            state.selectedSubmissionIds = action.payload
        },
        resetSelectedSubmissionIds: state => {
            state.selectedSubmissionIds = []
        },
        openSubmission: (state, action) => {
            state.openedSubmissionId = action.payload.id
            if (action.payload.groups) state.groupsAtSubmissionOpenMoment = action.payload.groups
        },
        closeSubmission: state => {
            state.openedSubmissionId = null
            state.groupsAtSubmissionOpenMoment = null
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const submissionActions = submissionSlice.actions

export default submissionSlice.reducer
